import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Icon, { GLYPHS } from '../../../../../app/common/icon';
import styles from './styles.module.scss';
import { t } from '../../../../infra/i18n';
export var Header = function () { return (_jsxs("div", { className: styles['header-container'], children: [_jsx(Icon, { glyph: GLYPHS.engagement, size: "calendar" }), _jsx("span", { children: t('engage:customer_groups.header_description') })] })); };
